import styled from 'styled-components';

export const ToggleLabel = styled.label`
  display: flex;
  text-align: end;
`;

export const ToggleWrapper = styled.div`
  position: relative;
  margin-left: 15px;
  min-width: 45px;
`;

export const StyledToggle = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  width: 42px;
  height: 26px;
  border-radius: 15px;
  background: ${(props) => props.theme.black[50]};
  cursor: pointer;
  &::after {
    content: '';
    display: block;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    margin: 3px;
    background: ${(props) => props.theme.black[10]};
    box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);
    transition: 0.2s;
  }
`;

export const HiddenToggleInput = styled.input`
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  width: 42px;
  height: 26px;
  &:checked + ${StyledToggle} {
    background: ${(props) => props.theme.gold[60]};
    &::after {
      content: '';
      display: block;
      border-radius: 50%;
      width: 18px;
      height: 18px;
      margin-left: 21px;
      transition: 0.2s;
      background: ${(props) => props.theme.gold[20]};
    }
  }
`;
